export const PHASE_IN_BUY_ERROR_KEY = "page.pdp.phaseinout.purchase.error";
export const PHASE_IN_BUY_WARN_KEY = "page.pdp.phaseinout.purchase.warning";
